import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import {
  CommentInstance,
  CommentToEditObject,
} from "components/Common/Editor/Comments";

export interface EditorReduxState {
  activeCommentInstance: CommentInstance | undefined;
  allComents: CommentInstance[];
  isComment: boolean;
  commentToEdit: CommentToEditObject | undefined;
  commentInstanceToRemove: CommentInstance | undefined;
}

const initialState: EditorReduxState = {
  activeCommentInstance: undefined,
  allComents: [],
  isComment: false,
  commentToEdit: undefined,
  commentInstanceToRemove: undefined,
};

export const editorSlice = createSlice({
  initialState,
  name: "editor",
  reducers: {
    setActiveCommentInstance: (
      state: EditorReduxState,
      action: PayloadAction<CommentInstance | undefined>
    ) => {
      state.activeCommentInstance = action.payload;
    },
    setAllComments: (
      state: EditorReduxState,
      action: PayloadAction<CommentInstance[]>
    ) => {
      state.allComents = action.payload;
    },
    setIsComment: (state: EditorReduxState, action: PayloadAction<boolean>) => {
      state.isComment = action.payload;
    },
    setCommentToEdit: (
      state: EditorReduxState,
      action: PayloadAction<CommentToEditObject | undefined>
    ) => {
      state.commentToEdit = action.payload;
    },
    removeComment: (
      state: EditorReduxState,
      action: PayloadAction<CommentToEditObject | undefined>
    ) => {
      const commentToRemove = action.payload;
      const commentInstance = state.allComents.find(
        ({ uuid }) => uuid === commentToRemove?.commentInstanceId
      );
      const newCommentsInInstance = commentInstance?.comments.filter(
        ({ uuid }) => uuid !== commentToRemove?.comment.uuid
      );
      const activeCommentInstance = state.activeCommentInstance;
      if (commentInstance && newCommentsInInstance) {
        const newAllComments = [...state.allComents].map(
          (commentInstanceFromAllComments) => {
            if (commentInstanceFromAllComments.uuid === commentInstance.uuid) {
              return {
                ...commentInstanceFromAllComments,
                comments: newCommentsInInstance,
              };
            }
            return commentInstanceFromAllComments;
          }
        );
        state.allComents = newAllComments;
      }
      if (
        activeCommentInstance?.uuid === commentToRemove?.commentInstanceId &&
        commentInstance
      ) {
        state.activeCommentInstance = {
          ...commentInstance,
          comments:
            newCommentsInInstance || activeCommentInstance?.comments || [],
        };
      }
    },
    setCommentInstanceToRemove: (
      state: EditorReduxState,
      action: PayloadAction<CommentInstance | undefined>
    ) => {
      const commentInstancePayload = action.payload;
      if (commentInstancePayload) {
        state.allComents = [...state.allComents].filter(
          ({ uuid }) => uuid !== commentInstancePayload.uuid
        );
        state.activeCommentInstance = undefined;
      }
      state.commentInstanceToRemove = commentInstancePayload;
    },
    clearAllComments: () => {
      return initialState;
    },
  },
});

export const {
  setActiveCommentInstance,
  setAllComments,
  setIsComment,
  setCommentToEdit,
  removeComment,
  setCommentInstanceToRemove,
  clearAllComments,
} = editorSlice.actions;
export default editorSlice.reducer;
